import { Validation } from 'common/components/form/FormValidationDisplay';
import { FeedbackType, ValidationStatus } from 'common/types/validationStates';

export const getValidationState = (validation?: Validation) => {
    const isInvalid = validation?.state === ValidationStatus.ERROR;
    const isValid = validation?.state === ValidationStatus.SUCCESS;
    const isWarning = validation?.state === ValidationStatus.WARNING;

    const validationFeedbackType = isInvalid
        ? FeedbackType.INVALID
        : FeedbackType.VALID;

    return { isInvalid, isValid, isWarning, validationFeedbackType };
};
